module.exports = __webpack_public_path__ + "static/media/playb.d7f7f775.png";